import Axios from '../axios'
import { serialize } from '../utility/serialization'

// Coach invoice lifecycle actions (R3). These hit the coach invoice endpoints and are called
// directly from the Enrollments & Billing drawer, which refreshes the enrollment afterwards.

export function requestMarkInvoiceAsPaid(invoiceId, { paymentMethod, offlinePaymentDescription, sendEmail }) {
  return Axios.patch(`/api/v1/coach/invoices/${invoiceId}/mark_as_paid`, serialize({ paymentMethod, offlinePaymentDescription, sendEmail }))
}

export function requestMarkInvoiceAsOutstanding(invoiceId) {
  return Axios.patch(`/api/v1/coach/invoices/${invoiceId}/mark_as_outstanding`)
}

export function requestSendInvoiceReminder(invoiceId) {
  return Axios.post(`/api/v1/coach/invoices/${invoiceId}/send_reminder`)
}

export function requestRefundInvoice(invoiceId, { refundAmount, notes, sendEmail }) {
  return Axios.post(`/api/v1/coach/invoices/${invoiceId}/refund`, serialize({ refundAmount, notes, sendEmail }))
}

export function requestUpdateInvoice(invoiceId, { paymentMethod, offlinePaymentDescription, notes, lineItems, packageId }) {
  return Axios.patch(
    `/api/v1/coach/invoices/${invoiceId}`,
    serialize({ invoice: { paymentMethod, offlinePaymentDescription, notes, lineItems, packageId } })
  )
}

// Attach a pricing package to an existing invoice-less enrollment (Billing-tab empty state → Add Pricing Package).
export function requestCreateInvoice(enrollmentId, { paymentMethod, notes, lineItems, packageId }) {
  return Axios.post('/api/v1/coach/invoices', serialize({ enrollmentId, invoice: { paymentMethod, notes, lineItems, packageId } }))
}
